import { WIDGET_TYPE } from '../../../constants';
import { WidgetType } from '../../../types';

import ServiceRequestWidget from './ServiceRequestWidget';

export const widgets: WidgetType[] = [
  { id: 'ServiceRequestWidget', type: WIDGET_TYPE.NORMAL, component: ServiceRequestWidget },
];
